import React from 'react'
import PropTypes from 'prop-types'
import {CategoryFilters, BANNER_TYPES} from './components/filters'

export const CategoryFiltersBanner = (props) => {
    return <CategoryFilters {...props} data-testid={'filters-CategoryFilters'} />
}

CategoryFiltersBanner.propTypes = {
    attributes: PropTypes.object,
    className: PropTypes.string,
    type: PropTypes.string,
    list: PropTypes.arrayOf(PropTypes.object),
    links: PropTypes.arrayOf(PropTypes.object)
}

export const CategoryFiltersBannerDefinition = {
    component: CategoryFiltersBanner,
    name: 'CategoryFiltersBanner',
    canHaveChildren: false,

    noWrap: true,
    shouldReceiveBuilderProps: {
        builderBlock: false
    },
    inputs: [
        {
            name: 'type',
            type: 'string',
            required: true,
            enum: Object.values(BANNER_TYPES),
            defaultValue: BANNER_TYPES.FILTERS
        },
        {
            name: 'list',
            type: 'list',
            showIf: `options.get('type') === '${BANNER_TYPES.FILTERS}'`,
            subFields: [
                {
                    name: 'Filter Label',
                    type: 'string',
                    defaultValue: 'Under $X'
                },
                {
                    name: 'Maximum Price',
                    type: 'string',
                    defaultValue: 'inf',
                    helperText: 'Sets pmax=x param, leave empty to ignore'
                },
                {
                    name: 'Minimum Price',
                    type: 'string',
                    defaultValue: '0',
                    helperText: 'Sets pmin=x param, leave empty to ignore'
                },
                {
                    name: 'Search parameters',
                    type: 'string',
                    defaultValue: '',
                    helperText:
                        'Parameters to append to the URL when clicking the filter link. Format: "key1=value1&key2=value2"'
                }
            ]
        },
        {
            name: 'links',
            type: 'list',
            showIf: `options.get('type') === '${BANNER_TYPES.LINK_AND_IMAGE}'`,
            subFields: [
                {
                    name: 'Label',
                    type: 'string',
                    defaultValue: ''
                },
                {
                    name: 'Link',
                    type: 'string',
                    defaultValue: '',
                    helperText:
                        'Absolute URL or relative path to the filter link. Example: "/category?filter=value"'
                },
                {
                    name: 'Image',
                    type: 'file',
                    allowedFileTypes: ['jpeg', 'png']
                }
            ]
        }
    ]
}
